const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(localStorage.getItem("and_utm") || "{}");
    let changed = false;
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v && !stored[k]) {
        stored[k] = v;
        changed = true;
      }
    });
    if (changed) localStorage.setItem("and_utm", JSON.stringify(stored));
    return stored;
  } catch {
    return {};
  }
}

export function getUtm() {
  try {
    return JSON.parse(localStorage.getItem("and_utm") || "{}");
  } catch {
    return {};
  }
}
